import { render, staticRenderFns } from "./LogMoreComponent.vue?vue&type=template&id=c215a820&scoped=true&"
import script from "./LogMoreComponent.vue?vue&type=script&lang=ts&"
export * from "./LogMoreComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LogMoreComponent.vue?vue&type=style&index=0&id=c215a820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c215a820",
  null
  
)

export default component.exports